import React, { useEffect, useState } from 'react';
import Loader from '../../../components/Loader';
import { getPublicClientConfig } from '../../../services/truststartService';
import InveriteView from './Inverite.view';
import buildIframeUrl from './build-iframe-url';
import {
  useInveriteEvents,
  useTrustStartMessages,
} from './hooks';

export default function InveriteContainer({
  clientId,
  requestId,
  onComplete,
  createScoringRequest,
  skipBankingSurvey,
  onError,
  bankId,
  showBackButton,
  webhookData,
}) {
  const [isLoadingBankingConfig, setIsLoadingBankingConfig] = useState(true);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [bankingConfig, setBankingConfig] = useState({});
  const [scoringRequestId, setScoringRequestId] = useState(requestId);

  const { isListening, showSkipBanking } = useInveriteEvents(
    clientId,
    scoringRequestId,
    onComplete,
  );
  useTrustStartMessages();

  useEffect(() => {
    async function loadBankingConfig() {
      const result = await getPublicClientConfig(clientId);
      setBankingConfig(result);
      setIsLoadingBankingConfig(false);
    }
    loadBankingConfig();
  }, [clientId]);

  const onIframeLoad = async () => {
    if (iframeLoaded) return;
    setIframeLoaded(true);
    if (showBackButton) showBackButton();
    if (createScoringRequest) {
      const result = await createScoringRequest();
      if (!result || !result.requestId || result.error) {
        // eslint-disable-next-line no-console
        console.error('Unable to create scoring request', result);
        if (onError) onError();
        return;
      }
      setScoringRequestId(result.requestId);
    }
  };

  if (isLoadingBankingConfig || !isListening) return <Loader />;

  const handleOnSkipBanking = (didSkip) => {
    if (!didSkip) return;
    onComplete(true);
  };

  return (
    <InveriteView
      iframeSrc={buildIframeUrl(bankingConfig, webhookData, bankId)}
      onIframeLoad={onIframeLoad}
      clientId={clientId}
      requestId={requestId}
      skipBankingSurvey={skipBankingSurvey}
      onSkipBanking={handleOnSkipBanking}
      showButton={showSkipBanking}
    />
  );
}
